import { Avatar } from '@mui/material'
import { useEffect, useMemo, useState } from 'react'
import { IconUserPlaceholder } from '../../icons/IconUserPlaceholder'

type Props = {
  src?: string | null
  size?: number
  onClick?: () => void
}

function normalizeAvatarSrc(src?: string | null): string | null {
  if (src == null) return null
  const trimmed = src.trim()
  return trimmed.length > 0 ? trimmed : null
}

export const UserAvatar = ({ src, size = 40, onClick }: Props) => {
  const normalizedSrc = useMemo(() => normalizeAvatarSrc(src), [src])
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    setFailed(false)
  }, [normalizedSrc])

  const showFallback = !normalizedSrc || failed
  const iconSize = Math.max(12, Math.round(size * 0.6))
  const handleClick = showFallback ? undefined : onClick

  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        ...(showFallback
          ? {
              bgcolor: '#f0f8ff',
              color: '#41bbf0',
            }
          : {}),
        ...(handleClick ? { cursor: 'pointer' } : {}),
      }}
      src={showFallback ? undefined : normalizedSrc}
      onClick={handleClick}
      onError={() => setFailed(true)}
    >
      {showFallback ? <IconUserPlaceholder sx={{ fontSize: iconSize }} /> : null}
    </Avatar>
  )
}

